import React, { memo } from 'react';
import classNames from 'classnames';
import { BaseButton, IBaseButtonProps } from '@alycecom/ui';
import { darken, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import useResponsive from '../../hooks/useResponsive';
import { IAlyceCustomTheme } from '../../styles/alyceTheme';

const useStyles = makeStyles<IAlyceCustomTheme>(({ palette }) => ({
  buttonText: {
    lineHeight: '1.15 !important',
    color: `${palette.customStyling.secondaryCtaColor} !important`,
  },
}));

export interface IStyledSecondaryButtonProps extends IBaseButtonProps {
  children: React.ReactNode;
}

const StyledSecondaryButton = ({ children, ...buttonProps }: IStyledSecondaryButtonProps): JSX.Element => {
  const classes = useStyles();
  const { palette: colors } = useTheme<IAlyceCustomTheme>();
  const { isTablet } = useResponsive();

  return (
    <BaseButton
      width="100%"
      minHeight={48}
      height={isTablet ? 'auto' : 48}
      variant="outlined"
      color={colors.common.white}
      hoverColor={colors.common.white}
      bgColor={colors.customStyling.secondaryColor}
      hoverBgColor={darken(colors.customStyling.secondaryColor, 0.2)}
      borderColor={colors.green.dark}
      border="none"
      {...buttonProps}
    >
      <span className={classNames(classes.buttonText, 'actionButtonText-ie')}>{children}</span>
    </BaseButton>
  );
};

export default memo<IStyledSecondaryButtonProps>(StyledSecondaryButton);
